// extracted by mini-css-extract-plugin
module.exports = {"body":"Text_body__snVk8","heading":"Text_heading__py3Kv","pageHeading":"Text_pageHeading__Q687m","sectionHeading":"Text_sectionHeading__5vs31"};